import { api } from '../../lib/api';

export const GRN_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'Posted', label: 'Posted', tone: 'success' },
  { value: 'Cancelled', label: 'Cancelled', tone: 'danger' },
];

export const grnStatusMeta = (status) =>
  GRN_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

export const DISCREPANCY_REASONS = [
  { value: 'Damaged', label: 'Damaged' },
  { value: 'WrongItem', label: 'Wrong item' },
  { value: 'ShortDelivery', label: 'Short delivery' },
  { value: 'OverDelivery', label: 'Over delivery' },
  { value: 'QualityIssue', label: 'Quality issue' },
  { value: 'Expired', label: 'Expired / short shelf life' },
  { value: 'Other', label: 'Other' },
];

export const discrepancyReasonLabel = (value) =>
  DISCREPANCY_REASONS.find((r) => r.value === value)?.label || (value && value !== 'None' ? value : null);

export const grnDiscrepancyMeta = (status) =>
  ({
    Open: { label: 'Open', tone: 'danger' },
    Resolved: { label: 'Resolved', tone: 'success' },
  }[status]) || { label: 'None', tone: 'neutral' };

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const receivingApi = {
  list: (params = {}) => api.get(`/goods-receipts${toQuery(params)}`),
  get: (id) => api.get(`/goods-receipts/${id}`),
  // payload.post === false saves a draft (no side effects); true posts immediately.
  create: (payload) => api.post('/goods-receipts', payload),
  update: (id, payload) => api.put(`/goods-receipts/${id}`, payload),
  post: (id) => api.post(`/goods-receipts/${id}/post`),
  remove: (id) => api.del(`/goods-receipts/${id}`),
  cancel: (id, reason) => api.post(`/goods-receipts/${id}/cancel`, { reason: reason || null }),
  resolveDiscrepancy: (id, resolutionNotes) =>
    api.post(`/goods-receipts/${id}/resolve-discrepancy`, { resolutionNotes: resolutionNotes || null }),
  listActivity: (id, params = {}) => api.get(`/goods-receipts/${id}/activity${toQuery(params)}`),
};
